export class EntityGoneError extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, EntityGoneError.prototype);
    }
}
